var __templateData = function anonymous(locals
/**/) {
var buf = [];
buf.push("<div><page-errors v-if=\"errors.length\"></page-errors><slot v-else=\"v-else\"></slot></div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}